module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAApklEQVRIS+3UUQqDMAwG4D+HHegZZL54CAUPqLf4x6CClsYkYkHYfG3Ml6ZpBZU/qZwfPwCQXAD0IjJH2knyBaAzW5QCRwCtFzn846kqguSx5g62AjxIKcYNfKEzRFsLARpyBoeBHEktVIfgErBDpgQ02oQ9E9j3/PYWlQ70tkOuOqZVL5onuXbjzSmKJC8i1mNHcgXw9r6kGTKYO7AKsNb/gNUhfADcoYqfVJ3+UwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/X.png
// module id = lLw2
// module chunks = 4